<rid-klank-card
  class="block transition-transform"
  [class]="disabled() ? 'cursor-not-allowed' : 'cursor-pointer hover:-translate-y-1'"
  [klank]="klank()"
  [disabled]="disabled()"
  (click)="disabled() ? undefined : clicked.emit()"
/>
